var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"landing",attrs:{"id":"main"}},[_c('Header'),_c('router-view'),_c('Footer'),_c('RegisterModal'),_c('LoginModal'),_c('WaitingDialog'),_c('VerifyEmailSuccess'),_c('ForgotPassword'),_c('Remove2FASuccess')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }